import { render } from "./UpdateWidgetModal.vue?vue&type=template&id=105c972b&ts=true"
import script from "./UpdateWidgetModal.vue?vue&type=script&lang=ts"
export * from "./UpdateWidgetModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__